import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mx-auto" }
const _hoisted_2 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_3 = {
  key: 1,
  class: "font-bold"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }

import {
  ActionInternalNested,
  isNoOp,
  isTrans,
  isKeyCode,
  isMultipleKeyCodes,
  isLayer,
  isDefaultLayer,
} from "@/keyboard";
import { useKeycapStore } from "@/stores";
import KeyCodes from "@/components/keys/KeyCodes.vue";
import LayerAction from "@/components/keys/LayerAction.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HoldTapInner',
  props: {
    action: {},
    variant: {},
    bgColor: {},
    textColor: {}
  },
  setup(__props: any) {



const kc = useKeycapStore();

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(kc).use_hold_tap_icons)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.variant == 'tap')
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 0,
                  icon: "mdi:arrow-up-down"
                }))
              : (_openBlock(), _createBlock(_component_Icon, {
                  key: 1,
                  icon: "mdi:arrow-collapse-down"
                }))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.variant == 'tap')
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "T"))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, "H"))
          ], 64))
    ]),
    (_unref(isKeyCode)(_ctx.action) || _unref(isMultipleKeyCodes)(_ctx.action))
      ? (_openBlock(), _createBlock(KeyCodes, {
          key: 0,
          action: _ctx.action,
          max_length: 5,
          max_lines: 1,
          size_adjust: 1
        }, null, 8, ["action"]))
      : (_unref(isLayer)(_ctx.action) || _unref(isDefaultLayer)(_ctx.action))
        ? (_openBlock(), _createBlock(LayerAction, {
            key: 1,
            class: "scale-[70%]",
            layer: _unref(isLayer)(_ctx.action) ? _ctx.action.Layer : _ctx.action.DefaultLayer,
            bgColor: _ctx.bgColor,
            textColor: _ctx.textColor,
            isDefault: _unref(isDefaultLayer)(_ctx.action)
          }, null, 8, ["layer", "bgColor", "textColor", "isDefault"]))
        : (_unref(isNoOp)(_ctx.action))
          ? (_openBlock(), _createElementBlock("span", _hoisted_4))
          : (_unref(isTrans)(_ctx.action))
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "TRANS"))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, "…"))
  ], 64))
}
}

})